import { BaseEntity } from "../../../models/concrete/BaseEntity.mjs";
export class CartItem extends BaseEntity {
  product;
  price;
  oldPrice;
  quantity;
  sum;
  data;
  customDataFields;
  modification;
  options;
  optionsGroups;
  constructor(data) {
    super(data);
    this.product = {
      allowOutOfStock: data.product.allow_out_of_stock,
      brand: data.product.brand,
      category: data.product.category,
      code: data.product.code,
      id: data.product.id,
      imageId: data.product.image_id,
      imageIds: data.product.images_ids,
      name: data.product.name,
      newPrice: data.product.price_new,
      oldPrice: data.product.price_old,
      quantity: data.product.quantity,
      depth: data.product.depth,
      height: data.product.height,
      weight: data.product.weight,
      width: data.product.width,
      volume: data.product.volume,
      seats: data.product.seats,
      hasModifications: data.product.has_modifications,
      hasOptions: data.product.has_options,
      isProductSet: data.product.is_product_set,
      isNotAvailable: data.product.is_not_available,
      modificationsCount: data.product.modifications_count,
      optionGroupsCount: data.product.option_groups_count,
      reviewsCount: data.product.reviews_count,
      reviewsRating: data.product.reviews_rating,
      productSetChildrenCount: data.product.product_set_children_count,
      shortCharacteristics: data.product.short_characteristics,
      characteristicGroup: data.product.characteristicGroup,
      characteristicGroupId: data.product.characteristic_group_id,
      productSetImageDots: data.product.product_set_image_dots,
      productSetParents: data.product.productSetParents,
      files: data.product.files,
      options: data.product.options,
      optionsGroups: data.product.optionsGroups,
      bonusValue: data.product.bonus_value,
      url: data.product.url,
      totalBonusValue: data.product.bonus_value_total,
      isBonusesOutcoming: data.product.is_bonuses_outcoming,
      createdAt: data.product.created_at,
      updatedAt: data.product.updated_at,
      exchangeUpdatedAt: data.product.exchange_updated_at,
      additionalCategories: data.product.additionalCategories
    };
    this.customDataFields = data.customDataFields;
    this.options = data.options;
    this.optionsGroups = data.optionsGroups.map((t) => ({
      externalId: t.external_id,
      name: t.name,
      isMultiple: t.is_multiple,
      id: t.id,
      sort: t.sort,
      variantGroups: t.variantGroups,
      variants: t.variants.map((variant2) => ({
        name: variant2.name,
        price: variant2.price,
        id: variant2.id,
        sort: variant2.sort,
        depth: variant2.depth,
        height: variant2.height,
        weight: variant2.weight,
        width: variant2.width,
        volume: variant2.volume,
        seats: variant2.seats,
        sku: variant2.sku,
        exclusionIds: variant2.exclusion_ids,
        externalId: variant2.external_id,
        imageId: variant2.image_id,
        imagesIds: variant2.images_ids,
        isProduct: variant2.is_product,
        priceOld: variant2.price_old,
        priceOldValue: variant2.price_old_value,
        priceType: variant2.price_type,
        variantGroupId: variant2.variant_group_id,
        priceValue: variant2.price_value
      }))
    }));
    this.data = data.data;
    this.sum = data.sum;
    this.quantity = data.quantity;
    this.price = data.price;
    this.oldPrice = data.price_old;
    this.modification = data.modification ? {
      code: data.modification.code,
      id: data.modification.id,
      name: data.modification.name,
      oldPrice: data.modification.price_old,
      price: data.modification.price,
      quantity: data.modification.quantity,
      variants: data.modification.variants.map((v) => ({
        group: v.group,
        id: v.id,
        image: v.image,
        value: v.value
      }))
    } : void 0;
  }
  toJSON() {
    return { ...this };
  }
}
